import { StageTools } from '../types';

export const SOLUTION_TESTING_TOOLS: StageTools = [
  {
    category: "原型设计",
    tools: [
      {
        name: "Figma",
        icon: "",
        description: "专业的在线设计工具，支持实时协作",
        url: "https://www.figma.com",
        tags: ["原型设计", "UI设计"]
      },
      {
        name: "即时设计",
        icon: "",
        description: "国产在线设计工具，操作简单",
        url: "https://js.design",
        tags: ["原型设计", "设计协作"]
      }
    ]
  },
  {
    category: "用户测试",
    tools: [
      {
        name: "UserTesting",
        icon: "",
        description: "远程用户测试平台，收集真实反馈",
        url: "https://www.usertesting.com",
        tags: ["用户测试", "反馈收集"]
      },
      {
        name: "Maze",
        icon: "",
        description: "原型测试工具，提供详细的用户行为数据",
        url: "https://maze.co",
        tags: ["原型测试", "数据分析"]
      }
    ]
  },
  {
    category: "反馈管理",
    tools: [
      {
        name: "Typeform",
        icon: "",
        description: "创建美观的在线调查问卷",
        url: "https://www.typeform.com",
        tags: ["问卷调查", "反馈收集"]
      },
      {
        name: "金数据",
        icon: "",
        description: "专业的表单收集工具",
        url: "https://jinshuju.net",
        tags: ["表单收集", "数据分析"]
      }
    ]
  }
]; 